import { useQuery } from 'react-query';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import useSearch from 'hooks/useSearch';
import moment from 'moment/moment';
import { Grid } from '@mui/material';
import DateRangeFilter from 'components/ui/filters/items/DateRangeFilter';
import { NumericFormat } from 'react-number-format';
import { t } from 'i18next';

export default function ProfileSale() {
  const axiosPrivate = useAxiosPrivate();
  const date = {
    from: moment().startOf('month').format('YYYY-MM-DD'),
    till: moment().endOf('month').format('YYYY-MM-DD'),
  };
  const query = useSearch();
  const from = query.get('from');
  const till = query.get('till');

  const saleData = useQuery({
    queryKey: ['/admin/profile/kpi', from, till],
    queryFn: async () => {
      const response = await axiosPrivate.get(
        `/admin/profile/kpi?from=${from || date?.from}&till=${
          till || date?.till
        }`
      );
      return response?.data?.data;
    },
    // enabled: false,
    retry: 1,
    onError: (err) => {},
  });

  const { data } = saleData;
  const sumUzs =
    (data?.paymentsum * +data?.kpi?.payment) / 100 +
    (data?.startsum * +data?.kpi?.start_price) / 100;
  const sumUsd =
    (data?.paymentusd * +data?.kpi?.payment) / 100 +
    (data?.startusd * +data?.kpi?.start_price) / 100;

  // if (saleData?.isFetching || saleData?.isLoading)
  //   return (
  //     <div className='h-full p-28 flex justify-center'>
  //       <CircularProgress size={40} />
  //     </div>
  //   );

  return (
    <div>
      <h1 className='text-[20px]'>{t('profile.currentBalance')}</h1>
      <h1 className='text-base-color text-[30px]'>
        <NumericFormat
          value={sumUsd || 0}
          allowNegative={false}
          displayType={'text'}
          thousandSeparator={' '}
          decimalScale={1}
          className='text-inherit font-semibold mr-1'
          suffix={' USD'}
        />
        |
        <NumericFormat
          value={sumUzs || 0}
          allowNegative={false}
          displayType={'text'}
          thousandSeparator={' '}
          decimalScale={1}
          className='text-inherit font-semibold ml-1'
          suffix={' UZS'}
        />
      </h1>
      <div className='flex justify-end'>
        <DateRangeFilter />
      </div>
      <div className='divider' />
      <Grid container spacing={2} columns={12}>
        <Grid item xs={6}>
          <div className='p-4 bg-white rounded-lg shadow-md border border-gray-200'>
            <h2 className='text-lg font-semibold mb-2'>
              {t('boss.residentialComplex.allStartPayments')}
            </h2>
            <p className='text-xl font-bold'>
              <NumericFormat
                value={data?.startusd || 0}
                allowNegative={false}
                displayType={'text'}
                thousandSeparator={' '}
                decimalScale={1}
                className='text-inherit font-medium mr-1'
                suffix={' USD'}
              />
              |
              <NumericFormat
                value={data?.startuzs || 0}
                allowNegative={false}
                displayType={'text'}
                thousandSeparator={' '}
                decimalScale={1}
                className='text-inherit font-medium ml-1'
                suffix={' UZS'}
              />
            </p>
          </div>
        </Grid>
        <Grid item xs={6}>
          <div className='p-4 bg-white rounded-lg shadow-md border border-gray-200'>
            <h2 className='text-lg font-semibold mb-2'>
              {t('common.fields.sumAll')}
            </h2>
            <p className='text-xl font-bold'>
              <NumericFormat
                value={data?.paymentusd || 0}
                allowNegative={false}
                displayType={'text'}
                thousandSeparator={' '}
                decimalScale={1}
                className='text-inherit font-medium mr-1'
                suffix={' USD'}
              />
              |
              <NumericFormat
                value={data?.paymentsum || 0}
                allowNegative={false}
                displayType={'text'}
                thousandSeparator={' '}
                decimalScale={1}
                className='text-inherit font-medium ml-1'
                suffix={' UZS'}
              />
            </p>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
